import { Navigate, Outlet } from "react-router-dom";

const isAuthenticated = () => {
    console.log('localStorage-', localStorage.getItem("ACCESS_TOKEN"))
  return localStorage.getItem("ACCESS_TOKEN");
};

const PrivateRoute = () => {
    console.log('PrivateRoute,',isAuthenticated)
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
